export const actions = {
  BIBPRECIOS_FILTERED_LOAD_REQUESTED: 'BIBPRECIOS_FILTERED_LOAD_REQUESTED',
  BIBPRECIOS_FILTERED_LOAD_SUCCEEDED: 'BIBPRECIOS_FILTERED_LOAD_SUCCEEDED',
  BIBPRECIOS_FILTERED_LOAD_FAILED: 'BIBPRECIOS_FILTERED_LOAD_FAILED',

  BIBPRECIOS_DELETED_REQUESTED: 'BIBPRECIOS_DELETED_REQUESTED',
  BIBPRECIOS_DELETED_SUCCEEDED: 'BIBPRECIOS_DELETED_SUCCEEDED',
  BIBPRECIOS_DELETED_FAILED: 'BIBPRECIOS_DELETED_FAILED',

  BIBPRECIOS_FILTERED_BY_ID_REQUESTED: 'BIBPRECIOS_FILTERED_BY_ID_REQUESTED',
  BIBPRECIOS_FILTERED_BY_ID_SUCCEEDED: 'BIBPRECIOS_FILTERED_BY_ID_SUCCEEDED',
  BIBPRECIOS_FILTERED_BY_ID_FAILED: 'BIBPRECIOS_FILTERED_BY_ID_FAILED',

  BIBPRECIOS_INSERTED_REQUESTED: 'BIBPRECIOS_INSERTED_REQUESTED',
  BIBPRECIOS_INSERTED_SUCCEEDED: 'BIBPRECIOS_INSERTED_SUCCEEDED',
  BIBPRECIOS_INSERTED_FAILED: 'BIBPRECIOS_INSERTED_FAILED',

  BIBPRECIOS_UPDATED_REQUESTED: 'BIBPRECIOS_UPDATED_REQUESTED',
  BIBPRECIOS_UPDATED_SUCCEEDED: 'BIBPRECIOS_UPDATED_SUCCEEDED',
  BIBPRECIOS_UPDATED_FAILED: 'BIBPRECIOS_UPDATED_FAILED',

  BIBPRECIOS_GET_URL_EXCEL_FILE_REQUESTED: 'BIBPRECIOS_GET_URL_EXCEL_FILE_REQUESTED',
  BIBPRECIOS_GET_URL_EXCEL_FILE_SUCCEEDED: 'BIBPRECIOS_GET_URL_EXCEL_FILE_SUCCEEDED',
  BIBPRECIOS_GET_URL_EXCEL_FILE_FAILED: 'BIBPRECIOS_GET_URL_EXCEL_FILE_FAILED',

  BIBPRECIOS_PRODUCTOS_UPDATED_REQUESTED: 'BIBPRECIOS_PRODUCTOS_UPDATED_REQUESTED',
  BIBPRECIOS_PRODUCTOS_UPDATED_SUCCEEDED: 'BIBPRECIOS_PRODUCTOS_UPDATED_SUCCEEDED',
  BIBPRECIOS_PRODUCTOS_UPDATED_FAILED: 'BIBPRECIOS_PRODUCTOS_UPDATED_FAILED',

  BIBPRECIOS_PRODUCTOS_DELETED_REQUESTED: 'BIBPRECIOS_PRODUCTOS_DELETED_REQUESTED',
  BIBPRECIOS_PRODUCTOS_DELETED_SUCCEEDED: 'BIBPRECIOS_PRODUCTOS_DELETED_SUCCEEDED',
  BIBPRECIOS_PRODUCTOS_DELETED_FAILED: 'BIBPRECIOS_PRODUCTOS_DELETED_FAILED',

  BIBPRECIOS_PRODUCTOS_FILTERED_REQUESTED: 'BIBPRECIOS_PRODUCTOS_FILTERED_REQUESTED',
  BIBPRECIOS_PRODUCTOS_FILTERED_SUCCEEDED: 'BIBPRECIOS_PRODUCTOS_FILTERED_SUCCEEDED',
  BIBPRECIOS_PRODUCTOS_FILTERED_FAILED: 'BIBPRECIOS_PRODUCTOS_FILTERED_FAILED',
}

export const getBibPreciosFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.BIBPRECIOS_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const deleteBibPreciosAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBPRECIOS_DELETED_REQUESTED,
    id,
  })
}

export const getBibPreciosByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BIBPRECIOS_FILTERED_BY_ID_REQUESTED,
      payload: id,
    })
  }
}

export const onSubmitInsertBibPrecioFormAction = (dispatch, formData) => {
  dispatch({
    type: actions.BIBPRECIOS_INSERTED_REQUESTED,
    payload: formData,
  })
}

export const onSubmitUpdateBibPrecioFormAction = (dispatch, formData) => {
  dispatch({
    type: actions.BIBPRECIOS_UPDATED_REQUESTED,
    payload: formData,
  })
}

export const getBibPreciosExcelUrlAction = dispatch => {
  dispatch({
    type: actions.BIBPRECIOS_GET_URL_EXCEL_FILE_REQUESTED,
  })
}

export const getBibPreciosProductosFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.BIBPRECIOS_PRODUCTOS_FILTERED_REQUESTED,
    payload: filter,
  })
}

export const onSubmitBibPreciosProductosUpdateAction = (dispatch, data) => {
  dispatch({
    type: actions.BIBPRECIOS_PRODUCTOS_UPDATED_REQUESTED,
    payload: data,
  })
}

export const onSubmitBibPreciosProductosDeleteAction = (dispatch, data) => {
  dispatch({
    type: actions.BIBPRECIOS_PRODUCTOS_DELETED_REQUESTED,
    payload: data,
  })
}
